var Observable_1 = require('../../Observable');
var fromPromise_1 = require('../../observable/fromPromise');
Observable_1.Observable.fromPromise = fromPromise_1.PromiseObservable.create;
//# sourceMappingURL=fromPromise.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/observable/fromPromise.js
 ** module id = 318
 ** module chunks = 1
 **/